// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__D7Pl3"};